import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { ApplicationResponse } from "@src/common/domain/common.model"
import api from "@src/common/services/api.service"
import AppConstants from "@src/utils/app.constants"
import convertToForm from "@src/utils/payload-to-form-converter"
import { MomStore, NewMomRef } from "@src/views/mom/domain/mom.model"


export const fetchMomList = createAsyncThunk<
  any[], // The expected return type, a list of MOMMinimal
  { id: string; type: string } // The type of the arguments
>(
  "mom/fetchMomList", // Unique action type
  async ({ id, type }, { rejectWithValue }) => {
    try {
      const response = await api.get<ApplicationResponse<any[]>>(
        `${AppConstants.api}/mom?id=${id}&type=${type}`
      );
      
      return response.data.data || [];
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

    export const addMom = createAsyncThunk<void, any>(
        "mom/addMom",
        async (payload: any) => {
            const url = `${AppConstants.api}/mom`;
          const response = await api.post<ApplicationResponse<any>>(
            url,
            payload
          );
          return response.data.data || {};
        }
      );

      export const deleteMom = createAsyncThunk(
        "mom/deleteMom",
        async (id: string) => {
          try {
            const response = await api.delete<ApplicationResponse<any[]>>(
              `${AppConstants.api}/mom?id=${id}`
            );
            return response.data.data || [];
          } catch (err) {
            return [];
          }
        }
      );
      export const ViewMom = createAsyncThunk<any, string>(
        "mom/ViewMom",
        async (id) => {
          const response = await api.get<any>(
            `${AppConstants.api}/mom/info?id=${id}`
          );
          return response.data.data || {};
        }
      );
        
        const momSlice = createSlice({
            name: "mom",
            initialState: {
                minimal: {status: "loading", error: null, data: []},
                milestone :{},
                events:{}
            } as MomStore,
            reducers: {
                updateMomList:(state,action)=>{
                    state.minimal.data.push(action.payload)
                }
            },
            extraReducers: (builder) => {
                builder
                    .addCase(fetchMomList.pending, (state, action) => {
                        state.minimal = {
                            status: "loading",
                            data: [],
                            error: null
                        }
                    })
                    .addCase(fetchMomList.fulfilled, (state, action) => {
                        state.minimal = {
                            status: "idle",
                            data: action.payload,
                            error: null
                        }
                    })
                    .addCase(fetchMomList.rejected, (state, action) => {
                        state.minimal = {
                            status: "failed",
                            data: [],
                            error: action.error
                        }
                    })
        
            }
        })
        export const {updateMomList} = momSlice.actions;
        
        export default momSlice.reducer
